<template>
	<div>
		<transition>
      <div class="w-100 fixed-top" v-show="action_success.show">
        <b-row class="justify-content-center" no-gutters>
          <b-col cols="12" sm="8" md="6" lg="4" xl="4">
            <div class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(243, 255, 249); border-color: rgb(184, 254, 205) !important;">
              <p class="mb-0 body-3-1">{{action_success.message}}</p>
            </div>  
          </b-col>
        </b-row>
      </div>
    </transition>
		<div class="w-100 text-center py-3 border-bottom">
			<p class="body-2 mb-1">Lakukan pembayaran dalam waktu</p>
			<p class="heading-4-1 mb-0" v-if="timeout">00:00:00</p>
			<p v-else class="heading-4-1 mb-0">
				<template v-if="countdown.hours() < 10">
					0{{countdown.hours()}}:
				</template>
				<template v-else>
					{{countdown.hours()}}:
				</template>
				<template v-if="countdown.minutes() < 10">
					0{{countdown.minutes()}}:
				</template>
				<template v-else>
					{{countdown.minutes()}}:
				</template>
				<template v-if="countdown.seconds() < 10">
					0{{countdown.seconds()}}
				</template>
				<template v-else>
					{{countdown.seconds()}}
				</template>
			</p>
			<!-- <p class="body-3-3-1 mb-0">Sebelum Jumat, 24 Juli 2020, 17:25</p> -->
		</div>
		<div class="w-100 py-3 text-center border-bottom">
			<p class="body-3 mb-1">Jumlah yang harus dibayarkan</p>
			<p class="body-2-4 text-orange mb-1">{{formatCurrency(data.tagihan)}}</p>
			<p class="body-3 mb-0 text-green cursor-pointer" @click="copyAmount">Salin jumlah</p>
		</div>
		<div class="w-100 py-3">
			<div class="text-center">
				<p class="body-3 mb-2">Pembayaran via Channel Bank BPD Bali</p>
				<div class="w-100 mb-1 border-bottom text-center" v-if="channel == 'VA_ATM_BERSAMA'">
					<p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="showHideData('atm_bersama')" :class="{'body-2-2-3 text-green tab-active': toggle_data == 'atm_bersama', 'body-2-1' : toggle_data != 'atm_bersama'}">
						ATM Bersama
					</p>
					<p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="showHideData('ebanking')" :class="{'body-2-2-3 text-green tab-active': toggle_data == 'ebanking', 'body-2-1' : toggle_data != 'ebanking'}">
						E-Banking Lain
					</p>
					<p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="showHideData('bpd')" :class="{'body-2-2-3 text-green tab-active': toggle_data == 'bpd', 'body-2-1' : toggle_data != 'bpd'}">
						BPD Bali
					</p>
					<!-- <div class="text-center">
							<button class="btn btn-outline-secondary body-3 text-14">BPD Bali</button>
							<button class="btn btn-outline-secondary body-3 text-14">ATM Bersama</button>
							<button class="btn btn-outline-secondary body-3 text-14">E-Banking Lain</button>
					</div> -->

					<!-- <img @click="testConsole()" src="../../assets/img/icon/logo-bpd.png" class="d-inline-block align-middle mr-2" height="30">
					<p class="sub-heading-1-2 mb-0 d-inline-block align-middle" style="letter-spacing: 2px !important;">{{data.va}}</p> -->
				</div>
			</div>
			<div class="w-100 p-2" v-if="toggle_data == 'bpd'">
				<div class="w-100 mb-3 pb-3 border-bottom text-center">
					<img src="../../assets/img/icon/logo-bpd.png" class="mb-2" height="100">
					<p class="body-3 mb-0">Nomor id/tagihan</p>
					<div class="w-100 text-center no-ws">
						<p class="sub-heading-1-2 mb-0 d-inline-block align-middle mr-2" style="letter-spacing: 2px !important;">{{data.va_bpd_bali}}</p>
						<div class="d-inline-block align-middle ml-1 cursor-pointer">
							<svg @click="$copyText(data.va_bpd_bali)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g id="copy_24px">
								<path class="fill-primary" id="icon/content/copy_24px" fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1H4.5C3.39999 1 2.5 1.89999 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.39999 5 6.5 5.89999 6.5 7V21C6.5 22.1 7.39999 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.89999 20.6 5 19.5 5ZM8.5 21H19.5V7H8.5V21Z" fill-opacity="0.54"/>
								</g>
							</svg>
						</div>
					</div>
				</div>
				<div class="html-desc" v-html="how_to_pay_text" @click="copyText"></div>
				<!-- <div class=" text-left">
					<p class="body-2-4 mb-2">Panduan Pembayaran</p>
					<ol class="pl-0 body-2-2 ml-4 mb-0">
						<li>Masukkan username dan password / PIN (Mobile / Internet Banking)</li>
						<li>Pilih menu <strong>“Pembayaran”</strong></li>
						<li>Pilih <strong>“Pembayaran Tiket Pariwisata”</strong></li>
						<li>Pilih Input Nomor ID lalu Pilih <strong>“Tiket Monkey Forest Ubud”</strong></li>
						<li>Input Nomor id/tagihan</li>
						<li>Input PIN untuk melanjutkan transaksi.</li>
						<li>Selesai.</li>
					</ol>
				</div> -->
			</div>
			<div class="w-100 p-2" v-if="toggle_data == 'atm_bersama'">
				<div class="w-100 mb-3 pb-3 border-bottom">
					<img src="../../assets/img/icon/atm-bersama.jpg" class="mb-2" height="100">
					<p class="body-3 mb-0">Nomor Virtual Account</p>
					<p class="sub-heading-1-2 mb-0" style="letter-spacing: 2px !important;">{{data.va_atm_bersama}}</p>
				</div>
				<div class=" text-left">
					<p class="body-2-4 mb-2">Panduan Pembayaran</p>
					<ol class="pl-0 body-2-2 ml-4 mb-0">
						<li>Pilih Bahasa</li>
						<li>Masukkan PIN</li>
						<li>Pilih <strong>“Transaksi Lainnya”</strong></li>
						<li>Pilih <strong>“Transfer”</strong></li>
						<li>Pilih <strong>“Ke Rekening Bank Lain ATM Bersama/Link”</strong></li>
						<li>Masukkan nomor rekening tujuan Virtual Account <strong>{{data.va_atm_bersama}}</strong>, lalu tekan <strong>“Benar”</strong></li>
						<li>Silakan isi atau kosongkan nomor referensi transfer kemudian tekan <strong>“Benar”</strong></li>
						<li>Muncul Layar Konfirmasi Transfer yang berisi nomor rekening tujuan bank beserta jumlah yang dibayar,</li>
						<li>Jika sudah benar, Tekan <strong>“Benar”</strong>.</li>
						<li>Selesai</li>
					</ol>
				</div>
			</div>
			<div class="w-100 p-2" v-if="toggle_data == 'ebanking'">
				<div class="w-100 mb-3 pb-3 border-bottom">
					<img src="../../assets/img/icon/bank-transfer.png" class="mb-2" height="100">
					<p class="body-3 mb-0">Nomor Virtual Account</p>
					<p class="sub-heading-1-2 mb-0" style="letter-spacing: 2px !important;">{{data.va_ebanking}}</p>
				</div>
				<div class=" text-left">
					<div class="html-desc" v-html="payment_detail.how_to_pay"></div>
					<!-- <p class="body-2-4 mb-2">Panduan Pembayaran</p>
					<ol class="pl-0 body-2-2 ml-4 mb-0">
						<li>Login pada alamat internet Banking Anda</li>
						<li>Pilih menu <strong>“Transfer”</strong></li>
						<li>Pilih menu <strong>“Transfer Antar Bank”</strong></li>
						<li>Pilih bank tujuan <strong>“Bank BPD Bali”</strong></li>
						<li>Masukkan nomor rekening tujuan Virtual Account <strong>{{data.va_ebanking}}</strong></li>
						<li>Input nominal yang ingin ditransfer sesuai harga tiket di atas, lalu tekan <strong>"Benar"</strong></li>
						<li>Muncul Layar Konfirmasi Transfer yang berisi nomor rekening tujuan bank beserta jumlah yang dibayar</li>
						<li>Masukkan password atau pin</li>
						<li>Selesai</li>
					</ol> -->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	import {formatCurrency,formatDate} from '@/utils/index.js'
	import moment from 'moment';
	import Vue from 'vue'

	const copyText = (text) =>{
		Vue.prototype.$copyText(text)
	}
	
	export default{
		props:['data','channel','tx_date','type','payment_detail'],
		data(){
			return{
				toggle_data: 'bpd',
	      countdown: moment(),
	      timeout: false,
				action_success:{
          show: false,
          message: '',
          timer: 0
        },
				how_top_pay_btn: [],
				how_to_pay_text: ''
			}
		},
		computed:{
			show_success(){
        return this.action_success.show
      }
		},
		watch:{
			show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
		},
		mounted() {
      let testDateUtc = (this.type == 'hotel') ? this.tx_date : moment.utc(this.tx_date);
      let localDate = moment(testDateUtc);
      let localDate_1 = moment(testDateUtc);

      let current_formatted = moment().format("YYYY-MM-DD HH:mm:ss")
      // let current_formatted = moment().format('HH:mm:ss')
      // let current = moment(current_formatted, "HH:mm:ss")
      let created_at_formatted = moment(localDate).add(24,'h')
      let created_at = moment(created_at_formatted).format("YYYY-MM-DD HH:mm:ss")
      this.countdown = moment.duration(moment(created_at).diff(moment(current_formatted)))

      let looping = setInterval(() => {
          this.countdown = this.countdown.subtract(1, 'seconds')
        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
          clearInterval(looping)
          this.timeout = true
        }
        },1000)

			if(this.payment_detail.how_to_pay != ''){
				this.generateHowToPayWithBtn()
			}
				
		},
		created(){
			if (this.channel == 'VA_ATM_BERSAMA') {
				this.toggle_data = 'atm_bersama'
			}
		},
		methods: {
			...mapGetters(['getTicketPayment']),
			generateHowToPayWithBtn(save_data){
				let code = this.data.va_bpd_bali
				let replace_1 = this.payment_detail.how_to_pay.replaceAll('{{#}}',`{{${code}}}`)
				let replace_2 = replace_1.replaceAll('{{#',`{{${code}`)
				let replace_3 = replace_2.replaceAll('#}}',`${code}}}`)
				
				
				let start_code = this.test("{{",replace_3)
				let end_code = this.test("}}",replace_3)
				let mix = []
				this.how_top_pay_btn = []
				start_code.forEach((item,index)=>{
					mix.push({
						start: item,
						end: end_code[index]
					}) 
				})
				let final = replace_3
				for (let i = 0; i < mix.length; i++) {
					const el = mix[i];
					const ori = replace_3.substring(el.start+2,el.end)
					const new_data = {
						id : `copy-text${i}`,
						data : ori
					}
					this.how_top_pay_btn.push(new_data)
				}

				this.how_top_pay_btn.forEach((item,index)=>{
					let btn = `<svg id="copy-text${index}" class="ml-2 cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="copy_24px"><path class="fill-primary" id="icon/content/copy_24px" fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1H4.5C3.39999 1 2.5 1.89999 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.39999 5 6.5 5.89999 6.5 7V21C6.5 22.1 7.39999 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.89999 20.6 5 19.5 5ZM8.5 21H19.5V7H8.5V21Z" fill-opacity="0.54"/></g></svg>`
					final = final.replace('{{','')
					final = final.replace('}}',btn)
				})
				this.how_to_pay_text = final		
			},
			formatDate(date){
        return formatDate(date);
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      testConsole(){
      	console.log("payment : ", this.getTicketPayment())
      },
      showHideData(data){
      	if (this.toggle_data == data) {
	 				this.toggle_data = ''
	 			}else{
	 				this.toggle_data = data
	 			}
      },
      copyAmount(){
        var value = parseFloat(this.data.tagihan);
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = 'Total tagihan telah di salin'
        this.action_success.timer = 2
      },
			copyText(e){
				let clickedElId = e.target.id
				let index_btn = this.how_top_pay_btn.findIndex(x=>x.id == clickedElId)
				if (index_btn != -1) {
					this.$copyText(this.how_top_pay_btn[index_btn].data)
				}
			},
			test(searchStr, str, caseSensitive){
				var searchStrLen = searchStr.length;
				if (searchStrLen == 0) {
						return [];
				}
				var startIndex = 0, index, indices = [];
				if (!caseSensitive) {
						str = str.toLowerCase();
						searchStr = searchStr.toLowerCase();
				}
				while ((index = str.indexOf(searchStr, startIndex)) > -1) {
						indices.push(index);
						startIndex = index + searchStrLen;
				}
				return indices;
			},
			generateCode(how_to_pay,code){
				let btn = '<svg id="click-copy" class="ml-2 cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="copy_24px"><path class="fill-primary" id="icon/content/copy_24px" fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1H4.5C3.39999 1 2.5 1.89999 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.39999 5 6.5 5.89999 6.5 7V21C6.5 22.1 7.39999 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.89999 20.6 5 19.5 5ZM8.5 21H19.5V7H8.5V21Z" fill-opacity="0.54"/></g></svg>'
				let code_with_button = `{{${code}}}`
				let replace_1 = how_to_pay.replaceAll('{{#}}',`{{${code}}}`)
				let replace_2 = replace_1.replaceAll('{{#',`{{${code}`)
				let replace_3 = replace_2.replaceAll('#}}',`${code}}}`)
				
				
				let return_data = replace_3
				// let split_text = how_to_pay.split('{#}')
				// if(split_text.length > 1){
				// 	split_text.forEach((item,index)=>{
				// 		return_data += item
				// 		if(index+1 < split_text.length){
				// 			return_data += (code+btn)
				// 		}
				// 	})
				// }else{
				// 	return_data = how_to_pay
				// }
				return return_data
			}
		}
	}
</script>
<style scoped>
	.rotate-180{
		transform: rotate(180deg);
	}
	.tab-active{
		border-bottom: 2px solid #79a33a;
	}
</style>


// WEBPACK FOOTER //
// src/components/ticket/VirtualAccountForm.vue